import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    wrapper: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
